/**
 * @file index.tsx
 *
 * @fileoverview Renders job detail body.
 */

import { Job } from '~/jobiqo/types/types';
import SharingButtons from '~/jobiqo/components/SocialMedia/SharingButtons';
import JobDetailShowAllTerms from '~/jobiqo/components/Job/Detail/components/ShowAllTerms';
import JobDetailBodyDescription from '~/jobiqo/components/Job/Detail/components/Body/Description';
import JobBodyExtraInfoSlot from '~/jobiqo/components/Slots/JobBodyExtraInfoSlot';
import JobDetailAttachmentButton from '~/jobiqo/components/Job/Detail/components/JobAttachment';
import { Spacing } from '~/vcl/atoms/06-layout/07-spacing';
import JobDetailVideo from '~/jobiqo/components/Job/Detail/components/Video';
import { useFrontendConfig } from '~/jobiqo/context/frontendConfig';

export interface JobDetailBodyProps {
  /**
   * The job.
   */
  job: Job;
  /**
   * Dimension from useDimensions hook.
   */
  dimensions: any;
  /**
   * Flag indicating if the job is iframe.
   */
  isIframe: boolean;
  /**
   * If the job is being previewed.
   */
  isPreview?: boolean;
  /**
   * If external anchors in the main job description should get rel=nofollow.
   */
  noFollowExternalLinks?: boolean;
  /**
   * If external anchors in the main job description should be rendered as plain text.
   */
  plainTextExternalLinks?: boolean;
}

export const JobDetailBody = ({
  job,
  isPreview,
  noFollowExternalLinks = false,
  plainTextExternalLinks = false,
  ...rest
}: JobDetailBodyProps) => {
  const { APP } = useFrontendConfig();
  const SOCIAL_ICONS_COLORED = APP.SOCIAL_ICONS_COLORED;

  return (
    <>
      <JobDetailVideo job={job} />
      <JobDetailBodyDescription
        job={job}
        noFollowExternalLinks={noFollowExternalLinks}
        plainTextExternalLinks={plainTextExternalLinks}
        {...rest}
      />
      <JobDetailShowAllTerms job={job} />
      <JobDetailAttachmentButton job={job} />
      <JobBodyExtraInfoSlot job={job} />
      {!isPreview && (
        <Spacing marginTop={8}>
          <SharingButtons
            url={job.urlNoPrefix ?? job.url.path}
            title={job.title}
            coloredIcons={SOCIAL_ICONS_COLORED}
            sharingEntity={job}
            sharingEntityType={'job'}
          />
        </Spacing>
      )}
    </>
  );
};

export default JobDetailBody;
